<script lang="ts">
  import { recommendation } from "../../stores/recommendation"

  import Button from "../Common/Button.svelte"
  import LinkButton from "../Common/LinkButton.svelte";

  function handleAddAllButtonOnClick () {
    recommendation.selectAll()
  }

  // TODO: Remove when apply full ADA PRR
  function handleReturnToTopButtonOnClick () {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }
</script>

<div class="bottom-buttons">
  {#if $recommendation.details?.brand.storeCartUrl}
    <Button
      active
      class="add-all-to-cart-button"
      on:click={handleAddAllButtonOnClick}
    >
      Add All to Cart
    </Button>
  {/if}
  {#if $recommendation.details?.brand.showAdaPrr}
    <LinkButton
      href="#"
      class="return-to-top-button"
    >
      Return to Top
    </LinkButton>
  {:else}
    <Button
      active
      class="return-to-top-button"
      on:click={handleReturnToTopButtonOnClick}
    >
      Return to Top
    </Button>
  {/if}
</div>

